import { Theme } from '@mui/system';
import { adjustFontSize } from '@theme/styleOverrides/typography';
import { ellipsis } from '@theme/styles';

const overflowTooltipStyle = {
  padding: '8px 16px',
  '.MuiTooltip-arrow': {
    fontSize: ({ palette }: Theme) => `${adjustFontSize(24, palette.fontSize)}px`,
  },
  maxWidth: '90vw',
};

const tooltipStyle = {
  maxWidth: '400px',
  padding: '8px 16px',
  fontWeight: 'normal',
  fontSize: ({ palette }: Theme) => `${adjustFontSize(14, palette.fontSize)}px`,
  '.MuiTooltip-arrow': {
    fontSize: ({ palette }: Theme) => `${adjustFontSize(24, palette.fontSize)}px`,
  },
};

const overflowingContentStyle = {
  maxWidth: '100%',
  ...ellipsis,
};

export { overflowTooltipStyle, tooltipStyle, overflowingContentStyle };
